export const MIN_ITEM_WIDTH = 20;
export const MIN_WIDTH_TO_SHOW_DATES = 96;
// Right inset matching the WeekHeader pill's pr-2 so items align with their date pill.
export const ITEM_RIGHT_INSET = 8;
export const ITEM_LANE_HEIGHT = 68;
export const ITEM_LANE_HEIGHT_COMPACT = 40;
export const ITEM_HEIGHT = 48;
export const ITEM_HEIGHT_COMPACT = 30;
export const ITEM_HEIGHT_WITH_LABELS = 64;
export const ITEM_TOOLTIP_DELAY = 600;
export const STALE_TIME_MS = 60 * 60 * 1000;
